import { Select } from '@wix/wix-ui-icons-common/on-stage';
import { unreachable } from '../../ts-utils';
export const getMarkedCommentIcon = (customBadgeIcon = { type: 'DEFAULT' }) => {
    switch (customBadgeIcon.type) {
        case 'CUSTOM': {
            return customBadgeIcon.icon;
        }
        case 'NONE': {
            return null;
        }
        case 'DEFAULT':
            return Select;
        default:
            throw unreachable(customBadgeIcon);
    }
};
//# sourceMappingURL=get-marked-comment-icon.js.map